const trips = {
  trips: 'Viagens',
  stopTypes: {
    charging: '',
    cluster: '(Centro de Cluster)',
  },
  statuses: {
    new: 'Novo',
    in_route: 'Em rota',
    sent: 'Enviado',
    approved: 'Aprovado',
    pickingUp: 'Recolhimento',
    done: 'Ok',
    canceled: 'Cancelado',
  },
  driverActions: {
    more: 'Mais',
    send: 'Enviar',
    call: 'Ligar',
    note: 'Nota',
  },
  moreActions: {
    actions: 'Mais',
    sendTrip: {
      title: 'Enviar Viagem',
      body: 'Você está prestes a enviar {{tripsCount}} viagens.',
    },
    delete: {
      title: 'Remover',
      body: 'Você está prestes a excluir {{tripsCount}} viagens.',
    },
    addNote: {
      title: 'Adicionar observação',
      body: 'Você está prestes a adicionar uma nota a viagens {{tripsCount}}.',
    },
    showOnMap: 'Mostrar no mapa',
    sendMessage: {
      title: 'Enviar mensagem',
      body: 'Você está prestes a enviar uma mensagem aos motoristas {{tripsCount}}.',
    },
    merge: {
      title: 'Fundir viagens',
      body: 'Você está prestes a fundir {{tripsCount}} viagens.',
    },
    cancelTrip: {
      title: 'Cancelar Viagem',
      body: 'Você está prestes a cancelar {{tripsCount}} viagens.',
    },
    export: 'Exportar',
    tripReports: 'Relatórios de Viagem',
    clearAssinment: {
      title: 'Limpar atribuição',
      body: 'Você está prestes a limpar a atribuição para {{tripsCount}} viagens.',
      confirmButton: 'Confirmar',
      checkBoxSkipManuallyAssigned: 'Pular atribuições manuais nesta interface',
    },
    clearBlacklistedDrivers: {
      title: 'Limpar motoristas bloqueados?',
      body: 'Isto removerá quaisquer motoristas bloqueados das viagens selecionadas e das suas reservas associadas - as atribuições de motoristas existentes não são afetadas.',
      toastSuccess: 'Motoristas bloqueados removidos com sucesso.',
    },
    exportToKml: {
      title: 'Exportar KML',
      body: 'Você está prestes a exportar os arquivos KML para {{tripsCount}} viagens.',
    },
    exportTripDirections: {
      title: 'Exportar Direções de Viagem',
      body: 'Você está prestes a exportar arquivos Excel para {{tripsCount}} viagens.',
    },
    exportToOptibus: {
      body: 'Selecione um projeto Optibus para exportar as viagens:',
    },
  },
  tripInfo: {
    title: 'Viagem  ',
    formTabs: {
      detailsTab: 'Detalhes',
      historyTab: 'Histórico',
      assignInsightsTab: 'Atribuir estatísticas',
      analysis: 'Análise',
      feedback: 'Avaliação',
    },
    driverActions: {
      note: 'Nota',
      call: 'Chamada',
      send: 'Enviar',
      more: 'Mais',
    },
    toast: {
      assignment: 'Viagem atribuída com sucesso',
      toastSomethingWasWrong: 'Ocorreu um erro',
      toastActionEndTrip: 'Final de viagem disponível quando todos os passageiros forem desembarcados',
    },
    selectDriver: 'Selecione o Motorista',
    selectVehicle: 'Selecione o Veículo',
    bookingDetails: {
      title: 'Detalhes da reserva',
    },
    status: 'Status',
    headerBreakDown: 'Detalhamento da viagem',
    driverNotAssigned: 'Motorista não atribuído',
    vehicleNotAssigned: 'Veículo não atribuído',
    noDriver: 'Sem motorista',
    noCar: 'Nenhum Veículo',
    noService: 'Sem Serviço',
    seats: 'Assentos',
    originalStation: 'Estação original: ',
    newStation: 'Nova estação: ',
    moveStopHeader: 'Você está prestes a mover a parada na viagem: {{ tripId }}',
    date: 'Data',
    pickupTime: 'Horário de recolhimento',
    eta: 'ESTIMATIVA da próxima parada',
    passengers: 'Passageiros',
    stops: 'Paradas',
    distance: 'Distância',
    miles: 'ml',
    kilometers: 'km',
    accept: 'Aceitar',
    decline: 'Recusar',
    map: {
      switchRoute: {
        toasts: {
          success: 'Linha trocada com sucesso',
          failure: 'Ocorreu um erro ao alterar a linha',
        },
      },
      operators: {
        fetchError: 'Não é possível recuperar operadores',
        placeholder: 'Operadores',
        submit: {
          toasts: {
            success: 'Operadores atualizados com sucesso',
            error: 'Não é possível atualizar os operadores',
          },
        },
      },
      stopClusterDistance: ' ({{distance}}m para agruparse)',
    },
    modalEndTrip: {
      body: 'Por favor, marcar todos os passageiros como desembarque',
      header: 'Aviso!',
    },
    tripActions: {
      tripBreakdown: 'Detalhamento da viagem',
      note: 'Adicionar nota',
      history: 'Histórico',
      msg: 'Envie uma mensagem ao motorista',
      moveToCustomRulesLabel: 'Criar Regra Personalizada',
      start: {
        name: 'Início de viagem',
        title: 'Ação disponível para o status Aprovado',
      },
      end: {
        name: 'Fim da viagem',
        title: 'Final de viagem disponível quando todos os passageiros forem desembarcados',
      },
      cancel: 'Cancelar viagem',
      breakdown: 'Detalhamento da viagem',
    },
    stopActions: {
      queue: 'Adicionar à fila',
    },
    passengerActions: {
      queue: 'Adicionar à fila',
    },
    assignLog: {
      button: 'Atribuir informações',
      closeButton: 'Atribuir registro',
      table: {
        headers: {
          driver: 'Motorista',
          vehicle: 'Veículo',
          score: 'Pontuação',
          flag: 'Bandeira',
          minutes: 'Minutos',
          radius: 'Raio',
          seatCount: 'Contagem de Lugares',
          totalTrips: 'Total de Viagens',
          totalPrice: 'Preço Total',
        },
      },
    },
    analysis: {
      header: 'Detalhes adicionais sobre ações manuais podem ser encontrados na aba Histórico de Viagens/Reservas',
      table: {
        headers: {
          name: 'Nome',
          type: 'Tipo',
          description: 'Descrição',
          conflict: 'Conflito',
          item1: 'Item 1',
          item2: 'Item 2',
          origin: 'Origem',
          source: 'Fonte',
        },
      },
    },
    breakdown: {
      table: {
        headers: {
          id: 'Identificação',
          planned: 'Tempo planejado',
          date: 'Tempo solicitado',
          passenger: 'Passageiro',
          type: 'Tipo',
          from: 'De',
          to: 'Para',
          vin: 'VIN',
          make: 'Fazer',
          model: 'Modal',
          year: 'Ano',
          weight: 'Peso',
          height: 'Altura',
          width: 'Largura',
          length: 'Duração',
          price: 'Preço',
        },
      },
    },
    tripsInfoPlans: {
      toastStatusChanged: 'Status alterado',
      toastStopRemoved: 'Parada removida',
      toastTripRemoved: '[Trips] removido com sucesso',
      toastTripRemoveError: '[Trips] Não foi possível Remover',
      toastClearSuccess: '[Trips] Os motoristas e os veículos foram removidos com sucesso',
      toastClearError: '[Trips] Os motoristas e os veículos foram removidos com sucesso',
      toastTripCanceled: '[Trips] Cancelada com sucesso',
      toastTripCanceledError: '[Trips] Não foi possível Cancelar',
      toastJobRemoved: 'Reserva removida',
      toastJobCanceld: 'A reserva foi cancelada com sucesso',
      toastSomethingWasWrong: 'Ocorreu um erro',
      toastMergeSuccess: 'As viagens foram fundidas com sucesso',
      toastMergeManyLockedAssignments: 'Não é possível fundir viagens porque elas têm múltiplas atribuições bloqueadas',
      toastMergeError: 'Uma das viagens não está disponível para fundir',
      btnRemoveStop: 'Remover',
      reservationActions: {
        btnPickUp: {
          name: 'Recolhimento',
          title: 'Disponível apenas para status na rota',
        },
        btnDroppoff: {
          name: 'Deixado',
          title: 'Disponível apenas para status na rota',
        },
        btnNoShow: {
          name: 'No Show',
          title: 'Disponível apenas para status na rota',
        },
        btnCancel: 'Cancelar reserva',
        btnRemove: 'Remover da viagem',
      },
    },
    events: {
      chargingStationAdded: 'Estação de carregamento adicionada',
    },
    moveReservation: {
      successToast: 'Reserva movida con éxito',
      errorToast: 'Error al mover la reserva',
    },
    moveStops: {
      successToast: 'Paradas reordenadas com sucesso',
      errorToast: 'Falha ao reordenar as paradas',
    },
  },
  edit: {
    applyingEditChanges: 'Aplicando alterações',
    progress: {
      toastSuccess: 'Pontos de passagem salvos',
      toastError: 'Falha ao aplicar os pontos de passagem',
    },
    unsaved: {
      header: 'Alterações não salvas',
      body: 'Você tem alterações não salvas. O que deseja fazer?',
      confirm: 'Descartar alterações',
      cancel: 'Manter alterações',
    },
  },
  table: {
    floatingActions: {
      tooltips: {
        deleteNotNew: 'Pelo menos uma viagem não está no status new',
        noPermission: 'Ação não permitida: Permissão necessária',
        accept: 'Esta ação só está disponível para viagens com status `Accept` ou `Decline`.',
        decline: 'Esta ação só está disponível para viagens com status `Accept` ou `Decline`.',
      },
      assign: 'Atribuir',
      send: 'Enviar',
      cancel: 'Cancelar',
      delete: 'Remover',
      export: 'Exportar',
      merge: 'Fundir',
      sendMessage: 'Enviar mensagem',
      tripReport: 'Relatório de Viagem',
      showOnMap: 'Mostrar no mapa',
      addNote: 'Adicionar observação',
      exportToKml: 'Exportar para KML',
      exportTripDirections: 'Exportar Direções de Viagem',
      exportToOptibusPlanning: 'Exportar para Planejamento',
      exportToOptibusScheduling: 'Exportar para Programação',
      accept: 'Aceitar',
      decline: 'Recusar',
    },
    filters: {
      status: 'Status',
      profile: 'Perfis',
      attributes: 'Atributos',
      supplier: 'Fornecedores',
      driver: 'Motorista',
      vehicle: 'Veículo',
      from: 'De',
      to: 'Para',
      locations: 'Localizações',
      airportLocations: 'Localizações de Aeroporto',
      flightNumber: 'Número do Voo',
      airline: 'Companhia Aérea',
      flightStatus: 'Status do Voo',
      productionId: 'Identificador de produção',
      drivers: {
        onlyWithout: 'Viagens não atribuídas',
        onlyWith: 'Viagens atribuídas',
        all: 'Atribuídos e não atribuídos ',
      },
      vehicles: {
        onlyWithout: 'Veículo não atribuído',
        onlyWith: 'Veículo atribuído',
        all: 'Atribuídos e não atribuídos',
      },
      areas: 'Zonas',
    },
    buttons: {
      driver: 'Motorista',
      vehicle: 'Veículo',
    },
    statuses: {
      new: 'Novo',
      inRoute: 'Em rota',
      sent: 'Enviado',
      approved: 'Aprovado',
      pickingUp: 'Recolhimento',
      done: 'Ok',
      canceled: 'Cancelado',
    },
    indicators: {
      consistentPassengerRouting: 'Roteamento Consistente de Passageiros',
      error: 'Investigação',
      manualDispatched: 'Despacho Manual',
    },
    headers: {
      id: 'Identificação',
      indicators: 'Indicadores',
      status: 'Status',
      date: 'Data',
      from: 'De',
      to: 'Para',
      seats: 'Assentos',
      passenger: 'Passageiro',
      profile: 'Perfil',
      stops: 'Paradas',
      distance: 'Distância',
      duration: 'Duração',
      service: 'Serviço',
      flightInfo: 'Informações do Voo',
      flightNumber: 'Número do Voo',
      airline: 'Companhia Aérea',
      scheduledFlightTime: 'Horário Programado do Voo',
      actualFlightTime: 'Horário Real do Voo',
      flightStatus: 'Status do Voo',
      supplier: 'Fornecedor',
      driver: 'Motorista',
      car: 'Veículo',
      actions: 'Ações',
      attr: 'Atributos',
      externalId: 'Id externo',
      waitUntil: 'Aguarde até',
      line: 'Linha',
      reservationsExtendUntilDate: 'Esperar até',
      areas: 'Zonas',
    },
    footer: {
      totalSeats: 'Total de Assentos: {{seats}}',
    },
    cells: {
      isTwoWay: {
        toolTip: 'Ida e Volta',
      },
      shared: {
        toolTip: 'Viagem Compartilhada',
      },
      waitAndReturn: {
        toolTip: 'Esperar E Voltar',
      },
      chargingStops: {
        toolTip: 'Paradas de carregamento',
      },
      manualAssignment: {
        integration: {
          toolTip: 'Atribuido manualmente (Integração)',
        },
        noIntegration: {
          toolTip: 'Atribuido manualmente',
        },
      },
      bypassed: {
        toolTip: 'Configurações ignoradas por ação manual',
      },
      isManuallyAltered: {
        toolTip: 'Despacho Manual',
      },
      manualDispatch: {
        and: '&',
        reason: {
          grouped: 'Agrupado',
          manualRoute: 'Rota Manual',
          dragAndDrop: 'Arrastar e Soltar',
          manualRouteIntegration: 'Rota Manual (Integração)',
        },
      },
      car: {
        none: 'Nenhum Veículo',
      },
      driver: {
        none: 'Sem motorista',
      },
      supplier: {
        none: 'Sem Fornecedor',
      },
      actions: {
        approve: 'Aprovar',
        remove: 'Remover',
      },
    },
    actions: {
      autoAssign: {
        modal: {
          header: 'Resumo da Tarefa',
          body: {
            trips: {
              total: 'Total de Viagens',
              assigned: 'Total Atribuído',
              unassigned: 'Não Atribuído',
            },
            drivers: {
              autoAssigned: 'Atribuído Automaticamente',
              preAssigned: 'Pré-Atribuído',
              total: 'Total de Motoristas',
              totalDriversAssigned: 'Total Atribuído',
              unassigned: 'Não Atribuído',
            },
            vehicles: {
              total: 'Total de Veículos',
              used: 'Total Asignado',
            },
            insights: {
              title: 'Insights de Tarefas',
              assignmentTime: 'Tempo de Processamento de Atribuição',
              avgDistance: 'Distâncias Médias de Viagem',
              avgDistanceToPickup: 'Distância Média de Condução em Retorno Vazio',
              avgDuration: 'Duração Média de Viagem',
              avgDurationToPickup: 'Average Deadhead Driving Distance',
              avgPrice: 'Preço Médio',
              waitAvg: 'Tempo Médio de Inatividade',
            },
          },
        },
        errorModal: {
          header: 'Erro',
          body: 'Todas as viagens selecionadas já foram atribuídas. Para reatribuir motoristas, primeiramente apague a atribuição atual.',
        },
      },
      assign: {
        assign: 'Atribuir',
        clearDriversVehicle: 'Limpar Motoristas/Veículos',
        clearBlacklistedDrivers: 'Limpar motoristas bloqueados',
        advancedAssign: 'Atribuição avançada',
        modalHeader: 'Atribuir viagens',
        youAreAboutToAssign: 'Você está prestes a atribuir {{numberOfTrips}} viagens.',
      },
      merge: {
        errorMessage: 'Viagem adicional não encontrada para fundir',
        shuttle: 'Viagens de transporte não podem ser fundidas',
      },
      showOnMap: {
        header: 'Mostrar no mapa',
        shuttle: 'Viagens de transporte não podem ser fundidas',
      },
      export: {
        optibus: {
          header: 'Projetos',
          placeholder: 'Selecionar projeto',
          export: 'Exportar',
          success: 'As viagens selecionadas foram enviadas com sucesso para o projeto Optibus selecionado.',
        },
      },
      cancelReservation: 'Você está prestes a cancelar esta reserva',
      report: {
        header: 'Resumo da Linha',
        body: {
          totalTrips: 'Viagens',
          totalCost: 'Custo',
          totalPrice: 'Preço',
          totalJobs: 'Reservas',
          totalDuration: 'Duração',
          totalDistance: 'Distância',
          totalAssigned: 'Atribuído',
          totalUnassigned: 'Não atribuído',
          totalDrivers: 'Motoristas',
          averageJobs: 'Média Reservas',
          averageDistance: 'Distância Média',
          averageDuration: 'Duração Média',
        },
      },
    },
  },
};

export default trips;
